var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('horizontal-nav',{attrs:{"set_view":"","show_display":false,"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }